(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  function placeAfterpay() {
    if (!mobile.matches) return;

    const details = document.querySelector('.product-details');
    if (!details) return;

    const addButton = details.querySelector('.add-to-cart-button');
    const placement = details.querySelector('afterpay-placement, square-placement, [data-afterpay-placement]');
    if (!addButton || !placement) return;

    const anchor = addButton.closest('.product-form-buttons') || addButton.parentElement || addButton;
    const afterpayBlock = placement.closest('.shopify-block, [id^="shopify-block-"], .app-block') || placement.parentElement || placement;
    if (!anchor || !afterpayBlock || anchor.contains(afterpayBlock)) return;

    afterpayBlock.classList.add('gpt-afterpay-moved', 'gpt-afterpay-directly-under-atc');

    if (anchor.nextElementSibling !== afterpayBlock) {
      anchor.insertAdjacentElement('afterend', afterpayBlock);
    }
  }

  function start() {
    placeAfterpay();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        placeAfterpay();
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();
